import { Button, Stack, Typography } from '@mui/material'
import { FC } from 'react'

import {
  Maybe,
  PrepaidPointsPaymentSourceFragment,
} from '@/clients/utoniq-core/schema'
import { StorageImage, useRouter, useTranslation } from '@/core'
import { generateCreditCardLogoPath } from '@/core/creditCard'

type CreditCardPaymentProps = {
  /** 支払い情報 */
  paymentSource: Maybe<PrepaidPointsPaymentSourceFragment> | undefined
  /** カード登録後の戻り先の URL パス */
  goBackPath: string
  /** カード登録後の戻り先の URL パラメータ */
  queryParams?: Record<string, string>
  /** カード登録画面に遷移する際の実行関数 */
  onNavigate?: () => Promise<void>
}
// クレジットカード決済のラジオボタン用のコンポーネント
export const CreditCardPayment: FC<CreditCardPaymentProps> = ({
  paymentSource,
  goBackPath,
  queryParams = {},
  onNavigate,
}) => {
  const { t } = useTranslation('artistMembershipPurchaseProceed')
  const { routerPages, generatePath, router } =
    useRouter<Record<string, string>>()
  const handleRegister = async () => {
    await onNavigate?.()
    const path = generatePath(goBackPath, queryParams)
    router.push(routerPages.PaymentMethodSetting, {
      goBackPath: path,
    })
  }

  if (paymentSource) {
    return (
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center">
          <Typography variant="h5">
            {t('creditCard', 'クレジットカード決済')}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap={2}>
          <StorageImage
            height={25}
            src={generateCreditCardLogoPath(paymentSource.brand)}
            target="common"
          />
          <Typography variant="body2">
            {t('last4Digits', {
              number: paymentSource.last4,
            })}
          </Typography>
        </Stack>
      </Stack>
    )
  }
  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center">
        <Typography variant="h5">
          {t('creditCard', 'クレジットカード決済')}
        </Typography>
        <Button variant="text" color="primary" onClick={handleRegister}>
          {t('register', '登録')}
        </Button>
      </Stack>
      <Typography variant="caption" color="text.hint">
        {t('creditCardNotRegistered', '支払い情報が登録されていません')}
      </Typography>
    </Stack>
  )
}
